export default __webpack_public_path__ + "static/media/style.0ef03681.less";